import { useQuery } from 'react-query';
import { useCurrentUser } from '@qualio/ui-components';
import { companyApi } from '../services/companyApi';

export const BaseQueryKey = 'company';

export const useCompany = (enabled: boolean) => {
  const { companyId } = useCurrentUser();

  return useQuery([BaseQueryKey, companyId], () => companyApi.fetchCompany(companyId), {
    refetchOnWindowFocus: false,
    enabled,
  });
};
